import React, { Component } from 'react';
import PropTypes from 'prop-types'
import styles from './styles.scss';
import { withRouter } from 'react-router-dom';
import CONFIG from '../../config';
import http from '../../helpers/http';
import ListItem from '../../components/ListItem/ListItem';
import WModal from '../../components/WModal/WModal';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';

class Repair extends Component 
{
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    console.log('constructor props', props);
    this.state={
      item:{},
      items:[],
      qa_id: this.props.match.params.qa_id || '',
      show_spinner: false,
    }

  }

  componentDidMount(){

    //拉API
    console.log('componentDidMount')

    this.pullData(this.state.qa_id)

  }
  componentWillReceiveProps(nextProps) {
    
    let { match:{params:{qa_id=null}={}} ={} } = this.props
    let { match:{params:{qa_id:new_qa_id=null}={}} ={} } = nextProps
    console.log('componentWillReceiveProps', qa_id, new_qa_id, nextProps)
    // eslint-disable-next-line
    if (qa_id != new_qa_id)
    {
      this.pullData(new_qa_id)
    }
  }
  showRepair(action, reason){
    
    console.log(action, reason)

    console.log(window.FG)

    window.FG && window.FG.show_repair(action, reason)

  }
  pullData(qa_id){

    qa_id = qa_id || '';
    this.setState({ show_spinner: true });
    http.get(CONFIG.API_HOST + 'api/v1.3/repair/qa', 
             { qa_id: qa_id }, 
             (state, res) => 
    {
        this.setState({ show_spinner: false });
        
        if (res.code !== 200)
        {
          WModal.show(res.reason)

          return;
        }

        this.setState({
          item:res.data,
          items:res.data.items
        })
    })
  }
  render()
  {
    console.log('==================');

    const { match, location, history } = this.props

    console.log(match, location, history, this.props);

    return (
      <div className={styles.page_container}>

        <div className={styles.padding_container}>
          <div className={styles.repair_title}>
            簡易障礙排除
            { /* this.state.item.name ? this.state.item.name : "簡易障礙排除" */}
          </div>
          <div className={styles.repair_subtitle}>
            請選擇您要報修的項目
            {/*this.state.item.desc ? this.state.item.desc : "請選擇您要報修的項目" */}
          </div>

            {
              this.state.items.map((item, index) =>
                <div>
                  <div onClick={ () => {
                    console.log(item)
                    console.log(item.action)
                    if (item.action === 'show_answer')
                    {
                      this.refs['modal_answer_' + item.qa_id].show()
                    }
                    if (item.action === 'go_next')
                    {
                      this.props.history.push('/repair/' + item.qa_id)
                    }
                    if (item.action === 'show_repair')
                    {
                      this.refs['modal_repair_'+item.qa_id].show()}
                    }
                    
                  }>
                    <ListItem content={item} key={index}/>
                  </div>
                  <WModal
                    ref={'modal_answer_' + item.qa_id}
                    title="維修提示"
                    message={item.answer}
                    buttons={['確認']}
                    onClick={this.onModalClick} />

                  <WModal
                    ref={'modal_repair_'+item.qa_id}
                    title={item.name}
                    message="是否確認報修?"
                    btns={['取消']}
                    onClick={this.onModalClick}>
                    <div className={styles.btn_container}>
                      <div className={[styles.content_area, styles.btn_area].join(' ')}>
                        <button type="button" onClick={ () => { this.showRepair("0", "住家水管破裂"); this.refs['modal_repair_'+item.qa_id].close(); } }>報修住家</button>
                      </div>
                      <div className={[styles.content_area, styles.btn_area].join(' ')}>
                        <button type="button" onClick={ () => { this.showRepair("1", "公共區域磁磚破裂"); this.refs['modal_repair_'+item.qa_id].close(); } }>報修公共區域</button>
                      </div>
                    </div>
                  </WModal>
                </div>
              )
            }
        { this.state.show_spinner && <WMask><WSpinner/></WMask> }  
        </div>

      </div>
    );
  }
}

export default withRouter(Repair);




// WEBPACK FOOTER //
// ./src/views/Repair/Repair.js